'use strict';

module.exports = '3.30.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 335
// module chunks = 0